import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

import { PeerVm } from '../health-nav.models';

@Component({
  selector: 'app-peer-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './peer-card.component.html',
  styleUrl: './peer-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PeerCardComponent {
  @Input({ required: true }) peer!: PeerVm;
  readonly isFollowing = signal(false);

  toggleFollow(): void {
    this.isFollowing.update(value => !value);
  }
}
